export default "__VITE_ASSET__b28AQbVG__"